export default {
  SET_USER: 'SET_USER',
  SET_FULL_SCREEN_LOADER: "SET_FULL_SCREEN_LOADER",
};